import { Navigate, Outlet } from 'react-router-dom';
import { ROUTES } from '@/config/routes.config';
import { useUserRoles } from '@/hooks/useUserRoles';

/** Salary advance approvals require Country Manager, HR or administrator role. */
export function ManagerOrHRRoute() {
  const { isAdmin, isGlobalHR, isCountryHR, isCountryManager } = useUserRoles();
  return isAdmin || isGlobalHR || isCountryHR || isCountryManager
    ? <Outlet />
    : <Navigate to={ROUTES.DASHBOARD} replace />;
}
